/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { ReduxUtils } from '@spm/core';
import Constants from '../App/constants';
var featureName = 'LifeEventCategories';
var GET_LIFE_EVENT_CATEGORIES = ReduxUtils.generateFetchActionTypes(Constants.LIBRARY_ROOT, featureName);

/**
 * Specified the life event context.
 */
var LIFE_EVENT_CONTEXT = ReduxUtils.generateActionType(Constants.LIBRARY_ROOT, featureName, 'LIFE_EVENT_CONTEXT');

/**
 * Indicates if all life events are visible or not.
 */
var HAS_ALL_LIFE_EVENTS_VISIBLE = ReduxUtils.generateActionType(Constants.LIBRARY_ROOT, featureName, 'HAS_ALL_LIFE_EVENTS_VISIBLE');
export { GET_LIFE_EVENT_CATEGORIES, LIFE_EVENT_CONTEXT, HAS_ALL_LIFE_EVENTS_VISIBLE };